import { useEffect, useRef } from 'react';
import { useConfig, useQueryParams } from 'react-commons';
import { GraphQLClient } from '@mineko/graphql-client';
import DecryptPartnerToken, { DecryptPartnerTokenResponse } from '../../../gql/queries/DecryptPartnerToken';
import { useGlobalState } from '../../../state/persistence';

const useTokenQueryParam = () => {
  const { token = undefined } = useQueryParams<{ token: string }>();
  const { dispatchAppStore } = useGlobalState();
  const config = useConfig();
  const done = useRef(false);

  useEffect(() => {
    if (!done.current && token && config) {
      done.current = true;
      const client = new GraphQLClient(config.APP.REACT_APP_PARTNER_API_URL);
      client
        .runQuery<DecryptPartnerTokenResponse>(DecryptPartnerToken, { token })
        .then((response: DecryptPartnerTokenResponse) => {
          const { email, firstName, lastName, salutation } = response.DecryptPartnerToken;
          dispatchAppStore('email', email);
          dispatchAppStore('firstName', firstName);
          dispatchAppStore('lastName', lastName);
          dispatchAppStore('salutation', salutation);
        });
    }
  }, [token, config, dispatchAppStore]);
};

export default useTokenQueryParam;
